import React, { useEffect, useState } from 'react'
import { STORE } from '../../../store';
import { RatingScreen } from '../../../actions/common';
import { setUserRating } from '../../../services/bot';
import { useSelector } from 'react-redux';

import './index.css';
import PoweredBy from '../../PoweredBy';
import { updateTextInput } from "../../../actions";
import { updateBotHandler } from "../../../actions/botHandler";
import { transferToBot } from "../../../utilities/LiveChat";
import { updateEnvironment } from '../../../actions/environment.action';

export default function UserRating() {
  const design = useSelector((state: any) => state?.design);
  const configuration = useSelector((state: any) => state?.configuration);

  const [rating, setRating] = useState([
    false,
    false,
    false,
    false,
    false
  ]);
  const [ratingText, setRatingText] = useState({
    title: 'Rate the conversation',
    description: 'Thanks for Interacting with us!',
    closeButton: 'Close Chat',
    restartButton: 'Restart Chat'
  });


  useEffect(() => {
    if (configuration && configuration.chatMenu && configuration.chatMenu.userRatingCustomImage) {
      const element = document.getElementById('user-rating-image');
      if (element) {
        (element as any).src = configuration.chatMenu.userRatingCustomImage;

        const urlObj = new URL(configuration.chatMenu.userRatingCustomImage);
        const width = urlObj.searchParams.get("width");
        const height = urlObj.searchParams.get("height");

        (element as any).style.width = width ? width + 'px' : '100%';
        (element as any).style.height = height ? height + 'px' : '100%';
      }
    }
  }, [configuration])

  // configuration.chatMenu.isRatingEnabled
  useEffect(() => {
    if (!configuration?.chatMenu?.isRatingEnabled) {
      onClose();
    }

    if (configuration?.chatMenu?.chatRating) {
      setRatingText({
        title: configuration.chatMenu.chatRating.title || '',
        description: configuration.chatMenu.chatRating.description,
        closeButton: configuration.chatMenu.chatRating.closeButton,
        restartButton: configuration.chatMenu.chatRating.restartButton
      });
    }

  }, [configuration]);

  const onMouseEnter = (index: number) => {
    setRating(prev => {
      const rate = prev.map((rate, i) => index >= i ? true : false);
      return rate;
    })
  }

  const onClose = () => {
    STORE.dispatch(RatingScreen(false));
    if ((window as any).parent && (window as any).parent.BotPenguin) {
      const botpenguin = new (window as any).parent.BotPenguin();
      botpenguin.closeWindow();
      localStorage.setItem('bp-user-close', 'true');
    }
  }

  const onClick = async (index: number) => {
    try {
      await setUserRating(index);
      sessionStorage.setItem('BotPenguin_rating', String(index))
      onClose();
    } catch (error) {
      console.log({ error });
      onClose();
    }
  }

  const restartChatFlow = () => {
    STORE.dispatch(updateTextInput({ value: '', original: '' }));
    STORE.dispatch(updateBotHandler('BOT'));
    transferToBot(true);
    STORE.dispatch(RatingScreen(false));
    // resetting selected tags to [] when user refreshes chat flow
    STORE.dispatch(updateEnvironment({ selectedTags: [] }));
  }

  const closeWindow = () => {
    const botpenguin = new (window as any).parent.BotPenguin();
    botpenguin.closeWindow();
    localStorage.setItem('bp-user-close', 'true');
    STORE.dispatch(RatingScreen(false));
  }

  return (
    <>
      {configuration && configuration.chatMenu && configuration.chatMenu.hasOwnProperty('isRatingEnabled') &&
        <div className='flex flex-col justify-between h-dvh relative overflow-y-auto' id="user-rating">
          <div id='ele-12' className='flex flex-col justify-center items-center text-center'>
            <div id='ele-13' style={{ background: !design.userRatingCustomCSSBackground && design.themeColor ? design.themeColor : '' }} className='w-full text-center'>
              <img
                id='user-rating-image'
                src={process.env.REACT_APP_CDN + `/rating-screen.png`}
                alt="Rate us"
                style={{ ...(!configuration.chatMenu.userRatingCustomImage && { maxHeight: '256px' }) }}
                className='m-auto' />
            </div>
            <div id='ele-14' className='font-mSemiBold text-2xl mt-10'>{ratingText.title || 'Your Opinion Matters to Us!'}</div>
            <div id='ele-15' className='font-mRegular text-sm mt-4 pl-10 pr-10'>{ratingText.description || 'Your feedback is valuable! Let us know how we can make your next chat experience even better.'}</div>
            <div id='ele-16' className='flex justify-start items-start mt-6' style={{ height: '70px' }}>
              {
                rating.map((rate, index) => {
                  return <div  key={'rating ' + index}>
                    {
                      [0, 4].includes(index)
                        ? <>
                          <div className='ele-user-rating-img-container flex flex-col cursor-pointer'>
                            <img
                              width={54}
                              alt=""
                              className='p-2'
                              key={index}
                              src={rate ? `${process.env.REACT_APP_CDN}/filled_star_1.svg` : `${process.env.REACT_APP_CDN}/blank_star_1.svg`}
                              onMouseEnter={() => onMouseEnter(index)}
                              onMouseLeave={() => setRating([false, false, false, false, false])}
                              onClick={() => onClick(index + 1)}
                            />
                            <div className='ele-user-rating-text text-xs'>
                              {index === 0 ? 'Bad' : 'Good'}
                            </div>
                          </div>

                        </>
                        : <img
                          width={54}
                          alt=""
                          className='p-2'
                          key={index}
                          src={rate ? `${process.env.REACT_APP_CDN}/filled_star_1.svg` : `${process.env.REACT_APP_CDN}/blank_star_1.svg`}
                          onMouseEnter={() => onMouseEnter(index)}
                          onMouseLeave={() => setRating([false, false, false, false, false])}
                          onClick={() => onClick(index + 1)}
                        />
                    }
                  </div>
                })
              }
            </div >
            <div id='ele-20' className='rating-button mt-6 p-3 rounded-md cursor-pointer' onClick={closeWindow} style={{ background: design.themeColor || '#226CF4', color: 'white' }}>{ratingText.closeButton || 'Close'}</div>
            <div id='ele-21' className='rating-button mt-4 p-3 cursor-pointer' onClick={restartChatFlow} style={{ color: design.themeColor || '#226CF4' }}>{ratingText.restartButton || 'Restart'}</div>
          </div >
          <div id='ele-22' className="h-3 max-h-4 mb-4 text-sm text-center"><PoweredBy /></div>
          <div id='ele-23' className="absolute cross cursor-pointer" onClick={closeWindow}>
            <img
              src={process.env.REACT_APP_CDN + `/cross-1.svg`}
              alt="close" />
          </div>
        </div>
      }
    </>
  )
}
